module.exports = __webpack_public_path__ + "static/media/Hen.e2c5a0ab.ico";